import { podFulFillmentUtils } from '@thd-olt-component-react/fulfillment';

const {
  isInStockNearby,
  getNearbyStoreInStock,
  getDeliveryZipCookie,
} = podFulFillmentUtils;

const FULFILLMENT_LOCATION_STH = 'DirectShip';
const FULFILLMENT_METHOD_STH = 'ShipToHome';
const FULFILLMENT_METHOD_BOSS = 'ShipToStore';
const FULFILLMENT_METHOD_BOPIS = 'BOPIS';
const FULFILLMENT_METHOD_BODFS = 'DeliverFromStore';
const FULFILLMENT_METHOD_APPLIANCE = 'DirectDelivery';

export const getBopisLocation = (params) => {
  const { product = {}, store = {} } = params || {};
  if (isInStockNearby(product)) return getNearbyStoreInStock(product)?.locationId || '';
  return store?.storeId || '';
};

export const getSthLocation = ({ store }) => {
  return getDeliveryZipCookie()
        || store?.storeZip
        || FULFILLMENT_LOCATION_STH;
};

export const getFulfillmentLocation = (params) => {
  const { fulfillmentMethod = null, store = {}, product = {}, deliveryZipCode = null } = params || {};
  switch (fulfillmentMethod) {
  case FULFILLMENT_METHOD_STH:
    return getSthLocation({ store });
  case FULFILLMENT_METHOD_BOPIS:
    return getBopisLocation({ product, store });
  case FULFILLMENT_METHOD_BOSS:
    return store.storeId || '';
  case FULFILLMENT_METHOD_APPLIANCE:
  case FULFILLMENT_METHOD_BODFS:
    return deliveryZipCode || store.storeZip || '';
  default:
    return null;
  }
};